import { Button } from "@mui/material";

interface IProps {
  title: string;
  handleOpenModal: any;
  width?: string;
  height?: string;
  fontSize?: string;
  src?: any;
}

const ExitButton = ({
  title,
  handleOpenModal,
  height,
  width,
  fontSize,
  src,
}: IProps) => {
  return (
    <Button
      color="secondary"
      onClick={handleOpenModal}
      variant="contained"
      sx={{
        height: height || "36px",
        fontSize: "16px",
        textTransform: "none",
        bgcolor: "#C32248",
        gap: 1,
        cursor: "pointer",
        ":hover": {
          bgcolor: "primary.main",
        },
        ...(width && { width: width }),
      }}
    >
      {title}
      <img src={src} alt="exit" />
    </Button>
  );
};

export default ExitButton;
